import {useEffect} from 'react';
import {useAuthContext} from "../../hooks/context/useAuthContext";
import {useLoading} from "../../hooks/useLoading";

export const AuthInitializer = ({ children }) => {
    const { isAuthReady } = useAuthContext();
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {
        showLoading();
    }, []);

    useEffect(() => {
        if (isAuthReady) {
            hideLoading();
        }
    }, [isAuthReady]);

    if (!isAuthReady) return null;

    return children;
};

export default AuthInitializer;
